import { render } from "./ChartCriteria.vue?vue&type=template&id=af08befc&scoped=true"
import script from "./ChartCriteria.vue?vue&type=script&lang=js"
export * from "./ChartCriteria.vue?vue&type=script&lang=js"

import "./ChartCriteria.vue?vue&type=style&index=0&id=af08befc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af08befc"]])

export default __exports__